/** Reference library Row Level Security-backed row shapes (public.ref_*). */
/**
 * Columns safe to request for any list/browse/moderation view of ref_references.
 * Deliberately omits `body_html` and `pages_text` — those can be megabytes for
 * book-type rows and only the single-row viewer ever needs them.
 */
export const REFERENCE_LIBRARY_LIST_COLUMNS = 'id, owner_id, type, title, author_name, description, cover_url, r2_object_key, ' +
    'file_size_bytes, mime_type, page_count, duration_seconds, embed_url, body_html_url, tags, genre, ' +
    'is_platform, status, license_type, license_note, content_origin, moderation_status, ' +
    'moderation_notes, rejection_reason, moderated_at, moderated_by, submitted_at, ' +
    'content_sha256, body_sha256, needs_white_removal, source_format, body_conversion_status, ' +
    'body_conversion_error, created_at, updated_at';
